import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  titleAlterarNegociador: {
    color: '#034DDC',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  formAlterarNegociador: {
    marginTop: '20px',
  },
  negociadorAtual: {
    fontSize: '14px',
    marginBottom: '15px',

    '& span:first-child': {
      fontWeight: 700,
    },

    '& span:last-child': {
      fontWeight: 600,
      marginLeft: '8px',
    },
  },
  footerNovoNegociador: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
  },
});
